import { render, staticRenderFns } from "./EmployeeBasicInfoForm.vue?vue&type=template&id=3743a5a6&"
import script from "./EmployeeBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeBasicInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmployeeBasicInfoForm.vue"
export default component.exports